import type { Metadata } from "next";
import type { LocaleProps } from "@/types";


export type Locale = typeof locales[number];
export const locales = ["en", "fr", "zh", "ko"] as const;
export const defaultLocale = "en" satisfies Locale;
export const localeNames = {
  "en": "English",
  "fr": "Français",
  "zh": "Chinois",
  "ko": '한국어'
} satisfies { [k in Locale]: string };
export const localeEntries = Object.entries(localeNames) as [Locale, string][];

// export const excludeFromBuild = [
//   { locale: 'zh', page: "/blog", to: "/en/blog" },
//   // { locale: 'ko', page: "/blog", to: "/en/blog" }
// ]



// const buildPageMap: { [index: string]: Locale[] } = {
//   "/": [],
//   "/faq": [],
//   "/customer-service": [],

//   /* --- retail --- */
//   "/retail": [],
//   "/retail/faq": [],
//   "/retail/customer-service":[],
//   "/retail/become-partner": [],

//   /* --- blog --- */
//   "/blog":[],
//   "/blog/[articleSlug]": [],
//   "/blog/tag/[categorySlug]": [],
//   "/blog/tag": [],

//   /* --- about us --- */
//   "/about-us": [],

//   /* --- shipping --- */
//   "/shipping":[],

//   /* --- standalone --- */
//   "/download": [],
//   "/order-retailers": [],
//   "/vat-refund-calculator":[],

//   /* --- legal --- */
//   "/privacy-policy": [],
//   "/terms-and-conditions": [],
// }
export const defaultAppName = "Zapptax";
export const defaultSiteTitle = "Zapptax - Tax-free shopping on your mobile";
export const defaultMetaDescription = "The easiest way to get your tax refund on all your purchases in Europe.";


export const links = {
  login: "https://my.zapptax.com/",
  mediaKit: "https://zapptax.notion.site/Press-Kit-Jean-Marie-Wodon-Zapptax-182f6d6adfd9806fbb4ac4cd5a50235a",

  download: {
    appStore: "https://apps.apple.com/app/zapptax-shop-tax-free/id1254346990",
    playStore: "https://play.google.com/store/apps/details?id=com.zapptax.zapptax",
  },

  social: {
    instagram: "https://www.instagram.com/zapptax",
    facebook: "https://www.facebook.com/Zapptax",
    linkedIn: "https://www.linkedin.com/company/zapptax",
    redNote: "https://www.xiaohongshu.com/user/profile/617ea0870000000002025b8a",
    weChat: "weixin://profile/zapptax",
    weChat2: "http://weixin.qq.com/r/mp/YERNVYbEndvircI29xFy",
  },

  phone: {
    retail: {
      france: "+33 1 89 71 60 35",
      belgium: "+32 2 588 07 22",
      spain: "+34 919 49 62 31",
    },

    traveler: {
      france: "+33 1 78 90 04 42",
      belgium: "+32 2 880 59 12",
      spain: "+34 910 607 358",
      uk: "+44 207 04 82 473",
    },
  },

  email: {
    support: "support@zapptax.com",
    retail: "retail@zapptax.com"
  },

  // jobs: {
  //   en: "https://www.welcometothejungle.com/en/companies/zapptax",
  //   fr: "https://www.welcometothejungle.com/fr/companies/zapptax",
  //   zh: "https://www.welcometothejungle.com/en/companies/zapptax",
  // },
};


/* non-standard-language pages
 * -------------------------------------------------------------------------- */


export const koreanLocale = {
  code: "ko",
  name: "한국어", // "Korean"
} as const;


export const koreanShippingPageCanonicalUrl = (
  `${process.env.NEXT_PUBLIC_BASE_URL}/ko/shipping`
);


export async function getKoreanShippingPageAltHrefs(): Promise<LocaleProps["nonStandardAltHrefs"]> {
  // needed, otherwise "ReferenceError: Cannot access 'routing' before initialization"
  const { getPathname } = await import("@/i18n/navigation");

  return {
    ...Object.fromEntries(
      locales.map(locale => [locale, {
        locale,
        name: localeNames[locale],
        href: getPathname({ locale, href: "/shipping" }),
      }])
    ),
    [koreanLocale.code]: {
      locale: koreanLocale.code,
      name: koreanLocale.name,
      href: "/ko/shipping",
    },
  };
}


export async function getKoreanShippingPageCanonicalAltHrefs(): Promise<NonNullable<NonNullable<Metadata["alternates"]>["languages"]>> {
  // needed, otherwise "ReferenceError: Cannot access 'routing' before initialization"
  const { getAlternates } = await import("@/i18n/util");

  const { languages } = getAlternates(defaultLocale, "/shipping");

  return {
    ...languages,
    [koreanLocale.code]: koreanShippingPageCanonicalUrl,
  };
}
